import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { WithRouterProps, withRouter } from 'react-router';
import Text from 'components/Text';
import Tabs, { Props as TabsProps } from 'components/Tabs';
import { mountModal } from 'lib/modal';
import TabPanel from 'components/TabPanel';

function Title(props: { active: boolean; children?: React.ReactNode }) {
  const classes = classnames('NavigationTabs-tab', {
    'NavigationTabs-tab--active': props.active,
    'NavigationTabs-tab--inactive': !props.active,
  });

  return (
    <Text size="xxxsmall" smallCaps className={classes}>
      {props.children}
    </Text>
  );
}

declare var __DEV__: string;
declare var __TEST__: string;

type Tab = {
  indicator?: boolean;
  modal?: React.ReactElement;
  name: string;
  path?: string;
};

type Props = {
  tabs: Tab[];
} & Pick<TabsProps, Exclude<keyof TabsProps, 'tabActive' | 'children'>> &
  WithRouterProps;

export class NavigationTabs extends React.Component<Props> {
  static defaultProps = Tabs.defaultProps;

  render() {
    const { tabs, ...props } = this.props;

    if (__DEV__ || __TEST__) {
      tabs.forEach(tab => {
        if ((tab.path || tab.modal) && !(tab.path && tab.modal) === false) {
          throw new Error('NavigationTabs tab needs a path xor a modal -> must have either or');
        }
      });
    }

    const activeTab = tabs.findIndex(tab => {
      return !!(tab.path && this.props.router.isActive(tab.path));
    });

    return (
      <Tabs {...props} tabActive={activeTab} tabHeaderClass="NavigationTabs-tabHeader">
        {tabs.map<JSX.Element>((tab, index) => (
          <TabPanel
            key={tab.path}
            to={tab.path}
            disableActivationOnClick={!!tab.modal}
            indicator={tab.indicator}
            title={<Title active={index === activeTab}>{tab.name}</Title>}
            eventElementName="NavigationTabs"
            dataTestSelector={`${tab.name}`}
            onClick={() => {
              if (tab.path) {
                props.router.replace(tab.path);
              }

              if (tab.modal) {
                mountModal(tab.modal, this);
              }
            }}
          />
        ))}
      </Tabs>
    );
  }
}

export default withRouter(NavigationTabs);
